




import Vue from "vue";
import SamlAuthenticationError from "@/components/authentication/saml-authentication-error.component.vue";
export default Vue.extend({
  components: {
    "saml-authentication-error": SamlAuthenticationError,
  },
});
